import Recaptcha from "./recaptcha";

export default class DomEvents {
    init() {
        this.whenDomReady(() => this.loadRecaptcha());
    }

    loadRecaptcha() {
        const recaptcha = new Recaptcha();
        recaptcha.domInjection();
    }

    whenDomReady(callback) {
        const isDomLoading = document.readyState === "loading";

        if (isDomLoading) {
            document.addEventListener("DOMContentLoaded", callback, { once: true });
            return;
        }

        callback();
    }
}
